import { motion, useMotionValue, useSpring, useTransform } from "framer-motion";
import { useEffect } from "react";

function AnimatedBalance({ balance }) {
    const motionValue = useMotionValue(0);
    const spring = useSpring(motionValue, { stiffness: 80, damping: 20 });

    const formatted = useTransform(spring, (val) =>
        "₦" + val.toLocaleString("en-NG", { minimumFractionDigits: 2 })
    );

    useEffect(() => {
        motionValue.set(Number(balance));
    }, [balance, motionValue]);

    return <motion.p style={{ fontSize: 22, fontWeight: 700 }}><motion.span style={{ display: "inline-block" }} >{formatted}</motion.span></motion.p>;
}

export default AnimatedBalance;